import { hiddenUserData } from "helpers/hiddenData";
import React from "react";
import configByName from "./configs/configByName";
import Template, { statuses } from "./template";

class Driver extends Template {
    infoText = () => {
        const { phoneNumber } = this.state.user || {};
        if (!phoneNumber) {
            return null;
        }
        return (
            <div className="offset-sm-4 offset-md-3 col-sm-8 col-md-5">
                <small className="text-muted">Номер телефона: {hiddenUserData(phoneNumber, { type: "phone" })}</small>
            </div>
        );
    };

    getItem = ({ value }) => {
        if (!value) {
            return this.setState({ user: null });
        }
        this.props
            .getItem({ id: value })
            .then((user) => this.setState({ user }))
            .catch(() => this.setState({ status: statuses.notFound }));
    };

    render() {
        const {
            value,
            config,
            // driverForwarderConfig,
            // renderCheckbox,
            showToggleSecondaryDriverBtn,
            setShowSecondaryDriver,
            isSecondaryDriver,
        } = this.props;
        return (
            <div className="form-group">
                {this.renderSelect({
                    ...config.id,
                    value,
                    fieldWrapper: "col-sm-8 col-md-5",
                    bWrapper: "row",
                    onNotFoundHandler: () => {
                        this.setState({ user: null });
                        this.setValue({ name: config.id.inputProps.name, value: null });
                    },
                })}
                <div className="row">{this.infoText()}</div>
                {/* {!isSecondaryDriver &&
                    driverForwarderConfig &&
                    renderCheckbox?.({
                        ...driverForwarderConfig,
                        fieldBeforeLabel: true,
                        labelWrapper: "col-auto col-form-label col-form-label-sm pl-0",
                        fieldWrapper: "col-auto offset-sm-4 offset-md-3 d-flex align-items-center",
                        bWrapper: "row",
                    })} */}
                {showToggleSecondaryDriverBtn && !isSecondaryDriver && (
                    <div className="row">
                        <div className="col-sm-8 col-md-5 offset-sm-4 offset-md-3 font-size-14">
                            <small className="link" onClick={() => setShowSecondaryDriver(true)}>
                                Добавить второго водителя
                            </small>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const Configured = (props) => {
    const config = props.isSecondaryDriver
        ? configByName.secondaryDriver()
        : configByName.driver(props.tripCouplingEnabled, props.firstPoint, props.action);
    return <Driver {...props} {...config} />;
};

export default Configured;
